import { ILineObject } from "../../../../../domain/editableFormat/objects";
import { ILineObjectBean } from "../../beans/objects";
import { AbstractObjectTranslator } from "./AbstractObjectTranslator";
import { PrintBehaviorTranslator } from "./properties";
import { VectorCoordinatableObjectTranslator } from "./base";

export class LineObjectTranslator extends AbstractObjectTranslator<ILineObject, ILineObjectBean> {
  constructor() {
    super(new VectorCoordinatableObjectTranslator());
  }

  overwriteObject(source: ILineObject, bean: ILineObjectBean, formatId: number): void {
    source.printBehavior = this.printBehavior.from(bean);
    source.lineStyle = {
      kind: this.integer.from(bean["@type"]),
      color: {
        value: this.colorCode.from(bean["@color"]),
      },
      width: this.integer.from(bean["@width"]),
      opacity: 1,
    };
  }

  overwriteBean(source: ILineObjectBean, object: ILineObject): void {
    source["@edit"] = "2";
    source["@hide"] = this.printBehavior.to(object).hide;
    source["@quote"] = "0";
    source["@type"] = this.integer.to(object.lineStyle.kind);
    source["@color"] = this.colorCode.to(object.lineStyle.color.value);
    source["@width"] = this.integer.to(object.lineStyle.width);
  }

  private readonly printBehavior = new PrintBehaviorTranslator();
}
